export default "__VITE_ASSET__b92ff6fc__"